import { TRecurringTaskTemplate } from '../../utils/types'

export const addGoalToTemplateHook = (goalIds: string[] | undefined, goalId: string): string[] =>
    Array.from(new Set([...(goalIds ?? []), goalId]))

export const removeGoalFromTemplateHook = (goalIds: string[] | undefined, goalId: string): string[] =>
    (goalIds ?? []).filter((id) => id !== goalId)

export const toggleHookSelection = (selectedIds: string[], id: string): string[] =>
    selectedIds.includes(id) ? selectedIds.filter((selectedId) => selectedId !== id) : [...selectedIds, id]

export const activeRecurringTemplates = (templates: TRecurringTaskTemplate[] = []): TRecurringTaskTemplate[] =>
    templates.filter((template) => !template.is_deleted)
